import { render, staticRenderFns } from "./NewInventory.vue?vue&type=template&id=194bd5da&"
import script from "./NewInventory.vue?vue&type=script&lang=js&"
export * from "./NewInventory.vue?vue&type=script&lang=js&"
import style0 from "./NewInventory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports